import { appConfig, headerConfig, refineHeader } from "../../config";

export const reportService = {
  saleReport,
  refundReport,
    refundarchiveReport,
  transactionReport,
  transactionallReport,
  RecurringCustomer,
  RecurringPayment,
  simpleTransaction,
  payoutReport,
  getReport,
  getMonth,
  merchantPayoutDetail,
  markPayment,
  addPayouComment,
  getPayoutComment,
  getPayoutHistory,
  exportAuctionBidder,
};

function saleReport(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/sales-report`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function refundReport(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/refund-paginate-report`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function refundarchiveReport(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/refund-archive-report`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function transactionReport(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/transaction-archive-report`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function transactionallReport(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/transaction-report`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function RecurringCustomer(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };
  
  return fetch(`${appConfig.api.url}report/Customer-Recurring`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function RecurringPayment(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };
  
  return fetch(`${appConfig.api.url}report/RecurringPayment`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function simpleTransaction(postData) {

  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/simple-transaction`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function payoutReport(postData, url) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
     body: JSON.stringify(postData)
  };
  // report/merchant-payout
  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getReport(postData, url) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getMonth() {
    refineHeader();
    const requestOptions = {
      method: "GET",
      headers: headerConfig.headerDatas
    };
  
    return fetch(`${appConfig.api.url}report/month-year`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data;
      });
}

function merchantPayoutDetail(postData) {
    refineHeader();
    const requestOptions = {
      method: "POST",
      headers: headerConfig.headerDatas,
      body: JSON.stringify(postData)
    };
  
    return fetch(`${appConfig.api.url}report/detail-merchant-payout`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data;
      });
}

function markPayment(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/mark-payment-merchant-payout`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function addPayouComment(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };
  return fetch(`${appConfig.api.url}report/add-comment-merchant-payout`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getPayoutComment(postData) {
    refineHeader();
    const requestOptions = {
      method: "GET",
      headers: headerConfig.headerDatas,
      body: JSON.stringify(postData)
    };
  
    return fetch(`${appConfig.api.url}report/comment-history-payout`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data;
    });
}

function getPayoutHistory(postData) {
    refineHeader();
    const requestOptions = {
      method: "POST",
      headers: headerConfig.headerDatas,
      body: JSON.stringify(postData)
    };
  
    return fetch(`${appConfig.api.url}report/pay-history-merchant-payout`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data;
      });
}
function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
function exportAuctionBidder(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}report/export-auction-bidder`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


// WEBPACK FOOTER //
// ./src/app/services/API/reportService.js